import { useContext } from 'preact/hooks';

import { useWindowSize } from '@/hooks';

import { IsMobileLayoutContext } from './contexts';
import { MOBILE_LAYOUT_BREAKPOINT } from './index';

export const useIsMobileLayout = () => useContext(IsMobileLayoutContext) === true;
export const useIsDesktopLayout = () => useContext(IsMobileLayoutContext) !== true;

/** Default landing route for mobile users (clips tab). */
export const MOBILE_LANDING_PATH = '/highlights';
/** Default landing route for desktop users. */
export const DESKTOP_LANDING_PATH = '/home';

/**
 * Returns the correct post-login/signup landing path based on viewport width.
 * Mobile users land on MOBILE_LANDING_PATH, desktop users land on DESKTOP_LANDING_PATH.
 * Use this instead of hardcoding paths in redirect logic.
 */
export const useDefaultLandingPath = () => {
  const [windowWidth] = useWindowSize();
  return windowWidth <= MOBILE_LAYOUT_BREAKPOINT ? MOBILE_LANDING_PATH : DESKTOP_LANDING_PATH;
};
